import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string;
    let newHeaders = req.headers;
    if(localStorage.getItem('token')){
      token = "Bearer " + localStorage.getItem('token').replace(/"/g, "");
      newHeaders = newHeaders.append('Authorization', token);
    }
    const authReq = req.clone({headers: newHeaders,withCredentials: true});
    return next.handle(authReq);
  }
}